/**
 * Home page wrapper with Header and API Keys integration
 */

import { Header } from './layout/Header';
import MCPBackoffice from './MCPBackoffice';

export function HomeWithHeader() {
  return (
    <div className='min-h-screen bg-gray-50 min-w-screen'>
      <Header />
      <MCPBackoffice />
    </div>
  );
}
